import { render, staticRenderFns } from "./DigitalAccreditation.vue?vue&type=template&id=405b6046"
import script from "./DigitalAccreditation.vue?vue&type=script&lang=js"
export * from "./DigitalAccreditation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports